"use client";

import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import cityData from "./citymain.json";
import BreadcrumbHero from "../BreadcrumbHero";
import HangingBoard from "../BreadCrumb/HangingBoard";
import Seo from "../Seo";
import MarketsSection from "../MarketsSection";
import CtaBanner from "../CtaBanner";
import LogoSlider from "../LogoSlider";
import WorkTogetherSection from "../service/WorkTogetherSection";
import Testimonials from "../Testimonials";
import rawClientLogos from "../client-logo.json";
import "../service/service-inner.css";

const PALETTE = [
  { bg: "#5856D610", edge: "#5856D6" },
  { bg: "#FF2D531A", edge: "#FF2D53" },
  { bg: "#00C7BD1A", edge: "#00C7BD" },
  { bg: "#A2855E1A", edge: "#A2855E" },
  { bg: "#AF52DE1A", edge: "#AF52DE" },
  { bg: "#34C7591A", edge: "#34C759" },
  { bg: "#e3ad0b1A", edge: "#e3ad0b" },
];

export default function LocationPage() {
  const logos = (rawClientLogos || []).map((item) => ({
    src: item.logo,
    alt: item.title || "",
  }));

  const { cityId } = useParams();
  const [hovered, setHovered] = useState(-1);

  const currentCity = cityData.find((c) => c.id === cityId);

  if (!currentCity) {
    return (
      <div style={{ backgroundColor: "#0a0a0a", minHeight: "100vh", paddingTop: "50px" }}>
        <h2 style={{ textAlign: "center", color: "white" }}>
          City not found!
        </h2>
      </div>
    );
  }

  return (
    <div>
      {/* 1. SEO SECTION */}
      <Seo
        title={`Top Digital Marketing & Web Services in ${currentCity.cityName} | HJ Sysweb`}
        description={`Grow your business in ${currentCity.cityName} with HJ Sysweb. We offer SEO, Branding, and Web Development to turn your traffic into revenue.`}
        canonical={`/location/${currentCity.id}`}
      />

      {/* 2. FIXED BREADCRUMB: Home > CityName */}
      <BreadcrumbHero
        title={`Services in ${currentCity.cityName}`}
        crumbs={[
          { label: "Home", href: "/" },
          { label: currentCity.cityName } // Ab "Locations" hat gaya hai, direct City aayega
        ]}
        bgImage="/Breadcrum/two-owl.png"
      />

      {/* 3. HANGING BOARD */}
      <HangingBoard
        text={`A strong digital presence in ${currentCity.cityName} helps businesses connect with the right audience, enhance visibility, and drive consistent growth through strategic planning, data-backed insights, and innovative approaches aligned with modern market trends.`.trimStart()}
        typingSpeed={25}  
      />  

      {/* 4. INTRO TEXT */}
      <div style={{ maxWidth: "900px", margin: "40px auto", textAlign: "center" }}>
        <p style={{ color: "#ccc", fontSize: "18px" }}>
         Grow your business faster with expert solutions in <strong>{currentCity.cityName}</strong> today.

        </p>
      </div>

      {/* 5. SERVICES ACCORDION (ss-stack) */}
      <div style={{ paddingBottom: "50px" }}>
        <div className="ss-stack" role="list">
          {currentCity.services.map((it, i) => {
            const isOpen = i === hovered;
            const col = PALETTE[i % PALETTE.length];

            return (
              <section
                key={it.id}
                className={`ss-item ${isOpen ? "open" : ""}`}
                style={{ "--bg": col.bg, "--edge": col.edge, marginLeft: '10%' }}
                onClick={() => setHovered(isOpen ? -1 : i)}
                onMouseEnter={() => setHovered(i)}
                onMouseLeave={() => setHovered(-1)}
              >
                <div className="ss-head">
                  <h1 className="ss-title">{it.name || it.title}</h1>
                  <Link
                    to={`/location/${cityId}/${it.id}`}
                    className="btn-outline"
                    style={{ padding: '8px 20px', borderRadius: '30px', fontSize: '14px', whiteSpace: 'nowrap', textDecoration: 'none' }}
                  >
                    View More
                  </Link>
                </div>

                <div id={`panel-${it.id}`} role="tabpanel" className="ss-body">
                  <div className="ss-body-inner">
                    <div className="ss-copy" style={{ textAlign: "justify" }}>
                      {it.description || it.desc ? (
                        <p className="ss-desc" style={{ marginBottom: "15px" }}>{it.description || it.desc}</p>
                      ) : null}

                      {(it.features || it.points)?.length ? (
                        <ul className="ss-list">
                          {(it.features || it.points).map((p, idx) => {
                            const colonIndex = p.indexOf(':');
                            if (colonIndex !== -1) {
                              const boldPart = p.slice(0, colonIndex + 1);
                              const rest = p.slice(colonIndex + 1);
                              return (
                                <li key={idx}><strong>{boldPart}</strong>{rest}</li>
                              );
                            }
                            return <li key={idx}>{p}</li>;
                          })}
                        </ul>
                      ) : null}
                    </div>

                    <div className="ss-art">
                      {it.image ? (
                        <img src={it.image} alt={it.name || it.title} style={{ width: '100%', height:'100%', objectFit: 'cover', borderRadius: 'inherit' }} loading="lazy" />
                      ) : null}
                    </div>
                  </div>
                </div>
              </section>
            );
          })}
        </div>
      </div>

      <MarketsSection />
      
      <CtaBanner
        headingSmall="Want to Grow your Business?"
        headingLarge="Turn Traffic Into Revenue"
        description="Share your website and monthly goal, we’ll reply with a short action plan."
        buttonText="Send Details"
        buttonLink="/contact-us"
      />

      <LogoSlider speed={100} logos={logos} />

      <WorkTogetherSection
        paras={
          currentCity.worktogether
            ? [currentCity.worktogether]
            : currentCity.desc
            ? [currentCity.desc]
            : []
        }
      />
      
      <Testimonials />
    </div>
  );
}